const apiUrl = process.env.REACT_APP_API_URL;

const postResetPassword = (data, cb) => {
    fetch(`${apiUrl}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default postResetPassword;
